import React from "react";
import { useTranslation } from "react-i18next";
import uploadSuccessImage from "../../../../public/images/upload-success.png";
import Button from "../../../common/components/Buttons/Button";
import ConfirmScreen from "../../../common/components/ConfirmScreen/ConfirmScreen";

interface Props {
  uploadAnotherTrack: () => void;
}
const UploadConfirmation = ({ uploadAnotherTrack }: Props) => {
  const { t } = useTranslation();

  return (
    <ConfirmScreen
      imageSrc={uploadSuccessImage}
      title={t("upload-success-title")}
      actions={
        <>
          <Button
            text={t("upload-another-track")}
            onClick={uploadAnotherTrack}
          />
        </>
      }
    />
  );
};

export default UploadConfirmation;
